/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module ExternalServicesModule */

const moduleName = 'external-services';
const componentName = 'customer-program';
const prefix = `${moduleName}.${componentName}`;

export const sharedDataLabel = `${prefix}.sharedDataLabel`;
export const cloudTypeCountLabel = `${prefix}.cloudTypeCountLabel`;
export const vsCountLabel = `${prefix}.vsCountLabel`;
export const vsWithWafCountLabel = `${prefix}.vsWithWafCountLabel`;
export const gslbSiteCountLabel = `${prefix}.gslbSiteCountLabel`;
export const gslbServiceCountLabel = `${prefix}.gslbServiceCountLabel`;
export const serviceEngineCountLabel = `${prefix}.serviceEngineCountLabel`;
export const dataLastSentLabel = `${prefix}.dataLastSentLabel`;
export const downloadFullMetricsLabel = `${prefix}.downloadFullMetricsLabel`;

export const ENGLISH = {
    [sharedDataLabel]: 'SHARED DATA',
    [cloudTypeCountLabel]: 'Cloud Type Count',
    [vsCountLabel]: 'VS Count',
    [vsWithWafCountLabel]: 'VS with WAF Count',
    [gslbSiteCountLabel]: 'GSLB Site Count',
    [gslbServiceCountLabel]: 'GSLB Service Count',
    [serviceEngineCountLabel]: 'Service Engine Count',
    [dataLastSentLabel]: 'Data Last Sent',
    [downloadFullMetricsLabel]: 'Download Full Metrics',
};
